/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types.generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** Autogenerated input type of AddShifts */
export type AddShiftsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  eventId: string | number;
  shifts: Array<ShiftInput>;
};

export type ShiftInput = {
  allowSelfSelect?: boolean | null | undefined;
  draft: boolean;
  endTime: string;
  roleName: string;
  startTime: string;
  volunteersRequired: number;
};

export type AddShiftsMutationVariables = Exact<{
  input: Types.AddShiftsInput;
}>;


export type AddShiftsMutation = { addShifts: { success: boolean, errors: Array<{ message: string, code: string, field: string | null }> } | null };


export const AddShiftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addShifts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddShiftsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addShifts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]} as unknown as DocumentNode<AddShiftsMutation, AddShiftsMutationVariables>;